import React from 'react';
import BaseComponent from '../BaseComponent';
import { MCButton, MCText, View } from '../basic';
import ShortInfo from './ShortInfo';
import { permissions, remCss, userFullName } from '../../helpers';
import { BASE_ICONS } from '../svg';
import LANG_CONST from '../../helpers/lang/const';

const paddingFooter = 500 * 0.1;

class InvitationPopup extends BaseComponent {
  render() {
    const { hide, data } = this.props;

    return (
      <div className={'mc-popup-contain'} style={{ width: 'auto' }}>
        <View
          style={{
            flexDirection: 'row',
            padding: remCss(25)
          }}
        >
          <ShortInfo user={{}} fullname={userFullName(data)} avatar={data.avatar} />
          <MCButton onClick={hide} iconname={BASE_ICONS.CLOSE} small padding={10} light circle />
        </View>
        <View
          style={{
            padding: remCss(25),
            gap: remCss(10),
            borderBottomWidth: 1,
            borderTopWidth: 1,
            borderBottomColor: '#86A5AA1A',
            borderTopColor: '#86A5AA1A'
          }}
        >
          <MCText label={data.title} weight={500} size={20} heading />
          <MCText label={LANG_CONST.text.invite_doctor} heading numberOfLines={2} />
        </View>
        <View
          style={{
            flexDirection: 'row',
            padding: paddingFooter,
            paddingBottom: paddingFooter - 15,
            gap: remCss(10),
            justifyContent: 'center'
          }}
        >
          <MCButton
            radius
            large
            flex
            primary
            dark
            label={LANG_CONST.buttons.accept}
            onClick={() => {
              hide();
              this.navigate(permissions.PAGES.INVITE_SIGNUP_PAGE.path + '?code=' + data.nItemId);
            }}
          />
        </View>
      </div>
    );
  }
}

export default InvitationPopup;
